export default __webpack_public_path__ + "static/media/liveCasino.6ab85426.png";